import { PERMISSIONS } from "../../utils/RolePermissionsMapping";

const standVirtualRoutes = {
  base: { route: "stand-virtual", name: "Stand Virtual" },
  dashboard: {
    main: { route: "dashboard", name: "Dashboard" },
    users: {
      route: "usuarios",
      name: "Administración de Perfiles/Usuarios",
      requiredPermissions: [
        PERMISSIONS.ADMIN_MANAGE_USERS,
        PERMISSIONS.USER_VIEW,
        PERMISSIONS.USER_SEARCH
      ]
    },
    configuracion: {
      route: "configuracion",
      name: "Configuración Stand Virtual",
      requiredPermissions: [
        PERMISSIONS.CONFIG_STAND_VIRTUAL,
        PERMISSIONS.CONFIG_STAND_VIRTUAL_VIEW
      ]
    },
    documentos: {
      route: "procedimientos",
      name: "Configuración de Documentos",
      requiredPermissions: [
        PERMISSIONS.CONFIG_DOCUMENTS,
        PERMISSIONS.CONFIG_DOCUMENTS_VIEW
      ]
    },
    reporteria: {
      route: "reporteria",
      name: "Reportería",
      requiredPermissions: [PERMISSIONS.REPORT_VIEW]
    }
  },
  procedimientos: { route: "procedimientos", name: "Procedimientos" },
  precertificacion: { route: "precertificacion", name: "Precertificación" },
  precertificacionNueva: {
    route: "precertificacion/crear",
    name: "Crear Precertificación"
  },
  precertificacionVer: {
    route: "precertificacion/:id",
    name: "Ver Precertificación"
  },
  precertificacionModificar: {
    route: "precertificacion/:id/modificar",
    name: "Ver Precertificación"
  }
};

export default standVirtualRoutes;
